import {
    ModuleOverviewListResolver,
    ModuleOverviewEditResolver
} from './services/module-overview.resolver.service';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModuleOverviewListComponent } from './components/module-overviewList.component';
import { CreateModuleOverviewComponent } from './components/Createmodule-overview.component';
import { ModuleOverviewComponent } from './module-overview.component';
import { ModuleOverviewServices } from './services/module-overview.service';
import { AppSharedModule } from './../shared/appShared.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { ConfirmationService, SharedModule } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MenuModule } from 'primeng/menu';
import { ContextMenuModule } from 'primeng/contextmenu';
import { EditorModule } from 'primeng/editor';
import { DatePickerModule } from 'primeng/datepicker';
@NgModule({ declarations: [ModuleOverviewComponent, ModuleOverviewListComponent, CreateModuleOverviewComponent],
    imports: [
        BrowserModule,
        RouterModule,
        TableModule,
        SharedModule,
        FormsModule,
        DatePickerModule,
        EditorModule,
        ReactiveFormsModule,
        ContextMenuModule,
        MenuModule,
        ConfirmDialogModule,
        AppSharedModule
    ],
    providers: [
        ModuleOverviewServices,
        ConfirmationService,
        ModuleOverviewListResolver,
        ModuleOverviewEditResolver,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ModuleOverviewModule {}
